import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class SharedPreferenceDataService {
    private checkSwiftStatus$ = new BehaviorSubject<boolean>(false);
    private checkNCashStatus$ = new BehaviorSubject<boolean>(false);
    swiftStatus$ = this.checkSwiftStatus$.asObservable();
    nCashStatus$ = this.checkNCashStatus$.asObservable();
    setSwiftValue(swift: boolean) {
        this.checkSwiftStatus$.next(swift);
    }
    setNCashValue(nCash: boolean) {
        this.checkNCashStatus$.next(nCash);
    }
}